import { Modal } from "@mui/material";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
const center = {
  lat: 20.5937,
  lng: 78.9629,
};
const LocationModal = ({ locationData, onClose }) => {
  const [map, setMap] = React.useState(null);
  const containerStyle = {
    width: 700,
    height: 700,
  };
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyA4ayX0TFGnC7CstosUjDgJawsYfMAZUFE",
  });

  const onLoad = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);

    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);
  if (loadError) {
    return <div>{JSON.stringify(loadError)}</div>;
  }

  if (!isLoaded) return <div>Loading Map...</div>;
  console.log(locationData);

  return (
    <Modal
      open={true}
      onClose={onClose}
      aria-labelledby="modal-title"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxHeight: "900px",
      }}
      aria-describedby="modal-description"
    >
      <div className="bg-white h-[90%] p-10 w-1/2 rounded-md overflow-scroll">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            cursor: "pointer",
            alignItems: "center",
          }}
        >
          <button onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div style={{ width: "100%", height: "100%" }}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={locationData?.startLocation ?? center}
            zoom={5}
            onLoad={onLoad}
            onUnmount={onUnmount}
          >
            <Marker
              key={`customer-34`}
              position={locationData?.startLocation}
              title={locationData?.customer?.name}
              icon={{
                // url: "/icons/customer.png", // your customer icon
                scaledSize: new window.google.maps.Size(40, 40),
              }}
              onClick={() => alert(`Start Location: ${locationData?.customer?.name}`)}
            />

            <Marker
              key={`customer-`}
              position={locationData?.endLocation}
              title={locationData?.customer?.name}
              icon={{
                // url: "/icons/customer.png", // your customer icon
                scaledSize: new window.google.maps.Size(40, 40),
              }}
              onClick={() => alert(`End location: ${locationData?.customer?.name}`)}
            />
            {/* Markers go here */}
          </GoogleMap>
        </div>
      </div>
    </Modal>
  );
};

export default LocationModal;
